module.exports = __webpack_public_path__ + "static/img/smoke-bkg.61bf055e.png";